<template>
    <Datepicker
        @closed="closed"
        v-model="val"
        placeholder="mm.dd.yyyy"
        inputFormat="MM.dd.yyyy"
        class="datepicker-input"
        :disabledDates="{
            dates: disabledDates
        }"
    />
</template>

<script setup>
import Datepicker from 'vue3-datepicker'
import {ref, defineProps, defineEmits, watch} from 'vue'

const props = defineProps({
    modelValue: {
        type: String,
        default: ''
    },
})
const emit = defineEmits(['update:modelValue'])

const val = ref(
    props.modelValue ? new Date(props.modelValue) : ''
)
let disabledDates = []

for (let i = 1; i < 365 * 10; i++) {
    let date = new Date()
    date.setDate(date.getDate() + i)

    disabledDates.push(date)
}

watch(props.modelValue, (nVal) => {
    val.value = new Date(nVal)
});

watch(val, (nVal) => {
    emit('update:modelValue', formatDate(nVal))
});

function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
}

function formatDate(date) {
    return [
        date.getFullYear(),
        padTo2Digits(date.getMonth() + 1),
        padTo2Digits(date.getDate())
    ].join('-');
}
const closed = function() {
    document.querySelectorAll('input').forEach(function(element){
        if(element === document.activeElement) {
            return element.blur();
        }
    });
}
</script>

<style>
.v3dp__popout {
    bottom: 100%;
}
.datepicker-input {
    padding-top: 19px!important;
    padding-bottom: 19px!important;
    border: 1px solid;
    width: calc(100% - 30px)!important;
}
</style>
